export default {
  "en": {
    "navbar": {
      "customer": {
        "after_care": "Aftercare",
        "dashboard": "Dashboard",
        "decisions": "Decisions",
        "documents": "Documents",
        "inspirations": "Inspirations",
        "installments": "Financials",
        "profile": "Your Profile",
        "projectinfo": "Information",
        "question_lists": "FAQ",
        "surveys": "Surveys",
        "ticket": {
          "new": "New Conversation"
        },
        "tickets": "Conversations",
        "units": "As-built"
      },
      "employee": {
        "client": "Profile {client}",
        "contacts": "Contacts",
        "customer": "Customer",
        "dashboard": "Dashboard",
        "employee": "Team member",
        "partner": "Partner",
        "profile": "Your Profile",
        "project": {
          "after_care": "Aftercare",
          "decisions": "Decisions",
          "documents": "Documents",
          "email_conversations": "Inbound emails",
          "info": "Information",
          "installments": "Financials",
          "news": "News Feed",
          "question_lists": "FAQs",
          "sales": "Sales (beta)",
          "surveys": "Surveys",
          "todos": "Tasks"
        },
        "projects": "Projects",
        "ticket": {
          "new": "New Conversation"
        },
        "tickets": "Conversations"
      },
      "partner": {
        "contacts": "Contacts",
        "dashboard": "Dashboard",
        "profile": "Your Profile",
        "project": {
          "after_care": "Aftercare",
          "decisions": "Decisions",
          "documents": "Documents",
          "tickets": "Conversations"
        },
        "projects": "Projects"
      },
      "supervisor": {
        "audit": "Audit",
        "clients": "Clients",
        "dashboard": "Dashboard",
        "emails": "Emails",
        "metrics": "Metrics",
        "users": "Users"
      },
      "topnavbar": {
        "company": "Company",
        "helpcenter": "Help Center",
        "logout": "Log Out",
        "profile": "Profile",
        "selectTeam": "Select company",
        "team": "Team"
      }
    }
  }
}